import { addDays, weekKey, type LocalDate } from './date';

/** さかのぼる上限（§5）。 */
export const STREAK_LOOKBACK_DAYS = 400;

/** activity から活動日（値が 1 以上の日）を取り出す（§5）。 */
export function activeDatesOf(activity: Readonly<Record<LocalDate, number>>): Set<LocalDate> {
  return new Set(
    Object.entries(activity)
      .filter(([, n]) => n >= 1)
      .map(([d]) => d),
  );
}

/**
 * ストリーク（progress-store.md §5。ベクタ S01〜S11）。
 * 起点は今日が活動日なら今日、でなければ昨日。週（月曜始まり）に 1 日まで休みを使える。
 * 休みはその日より前に活動日があるときだけ使える。
 */
export function computeStreak(activeDates: ReadonlySet<LocalDate>, today: LocalDate): number {
  if (activeDates.size === 0) return 0;
  let earliest: LocalDate | null = null;
  for (const d of activeDates) if (earliest === null || d < earliest) earliest = d;
  const restWeeks = new Set<LocalDate>();
  let day = activeDates.has(today) ? today : addDays(today, -1);
  let count = 0;
  for (let i = 0; i < STREAK_LOOKBACK_DAYS; i++, day = addDays(day, -1)) {
    if (activeDates.has(day)) {
      count += 1;
      continue;
    }
    const week = weekKey(day);
    if (!restWeeks.has(week) && earliest !== null && earliest < day) {
      restWeeks.add(week);
      continue;
    }
    break;
  }
  return count;
}
